export default {
    name: 'comercios',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-comercios',
            component: () => import('@/modules/comercios/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-comercios',
            component: () => import('@/modules/comercios/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-comercios',
            component: () => import('@/modules/comercios/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}